import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';

export const getFolderName = (folderId?: string) => {
    const selectedFolderId = folderId ?? getSelectedFolderId();
    const distinguishedFolderIdName = selectedFolderId ? folderIdToName(selectedFolderId) : null;

    if (!distinguishedFolderIdName) {
        return null;
    }

    return distinguishedFolderIdName === 'none' ? 'Custom' : distinguishedFolderIdName;
};
